export default "__VITE_ASSET__C010n0Yu__"